module.exports = __webpack_public_path__ + "static/media/browser.f7a90f55.png";